import { IoCContainer } from '@lmnop/web-core';
import {
    AngularWebsiteCoreIoCKeys,
    IExtendedCookieService,
} from 'angular-website-core-src';
import { IAngularWebsiteCoreIoCContainer } from './angular-website-core-ioc-container.interface';
import { CoreModulesIoC } from './core-modules-ioc.class';
import { IWebsiteCoreSettings, WebsiteCoreIoCKeys } from '@lmnop/website-core';

export class AngularWebsiteCoreIoCContainer
    implements IAngularWebsiteCoreIoCContainer
{
    public lateBindIoC(): void {
        this.core = new CoreModulesIoC();
        this.settings = IoCContainer.get(
            WebsiteCoreIoCKeys.IWebsiteCoreSettings
        );
        this.cookieService = IoCContainer.getThirdPartyInstance(
            AngularWebsiteCoreIoCKeys.IExtendedCookieService
        );
    }

    public core: CoreModulesIoC;
    public settings: IWebsiteCoreSettings;

    public cookieService: IExtendedCookieService;
}
